

import { registerAsIntegrationWebComponent } from "./webcomponents/registerAsIntegrationWebComponent";
import { REQUIRED } from "@infonova/framework/lib/webcomponents/util/REQUIRED";
import { JSXElements } from "src/infonova/infonova";
import { STRING } from "./webcomponents/STRING";
import { BaseComponent } from "../components/base/BaseComponent";
import Button from "../components/button/button";


/**
 * This allows for easier usage in other react components. (JSX.IntrinsicElements contains all known HTML components).
 */
declare global {
  namespace JSX {
    interface IntrinsicElements extends JSXElements {
      "example-component": {
        id: string;
      };
    }
  }
}

// export interface InfonovaUiBrandingApplication {
//     "infonova-ui-branding-application": CustomElement<Record<string, never>>;
// }

export class InfonovaUiWebComponentsConfiguration {
  static configure() {
    // registerAsIntegrationWebComponent adds the CSS to the web component.
    registerAsIntegrationWebComponent(
      {
        name: "base-component",
        attributes: [REQUIRED(STRING("id"))],
      },
      BaseComponent
    );

    registerAsIntegrationWebComponent(
      {
        name: "custom-button"
      },
      Button
    );

  }
}